import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LanguageService } from "libraries/service/language/language.service";

@Pipe({ name: 'priceRealAmount' })
export class PriceRealAmountPipe implements PipeTransform {
    constructor(
        private readonly currencyPipe: CurrencyPipe,
        private readonly decimalPipe: DecimalPipe,
        private readonly languageService: LanguageService,
        private readonly domSanitizer: DomSanitizer
    ) { }

    /**
     * Displays the currency depending on the locale:
     * the output can be 1 000,99 € (fr)
     * or $ 1,000.00 (us)
     *
     * This pipe's output is in HTML, digits are inside a <small> tag
     * @param price Number to display
     * @param currencyCode ISO code of the currency
     */
    public transform(price: number, currencyCode?: string, displayLike: string = 'symbol'): SafeHtml {
        if (price === null || price === undefined) {
            return "";
        }

        let withDigits;
        let withoutDigits;

        if (isNaN(price)) {
            return null;
        }

        const userLanguage = this.languageService.getUserLanguage();

        if (currencyCode) {
            withoutDigits = this.currencyPipe.transform(price, currencyCode || "", displayLike, '1.0-0', userLanguage);
            withDigits = this.currencyPipe.transform(price, currencyCode || "", displayLike, '1.2-2', userLanguage);
        } else {
            withoutDigits = this.decimalPipe.transform(price, '1.0-0', userLanguage);
            withDigits = this.decimalPipe.transform(price, '1.2-2', userLanguage);
        }

        let result = '';
        let identicalIndex = 0;

        for (let i = 0; i < withoutDigits.length; i++) {
            if (/[0-9]/.test(withDigits[i]) || withDigits[i] === withoutDigits[i]) {
                result += withDigits[i];
                identicalIndex = i;
            } else {
                break;
            }
        }

        // Gets the separator
        identicalIndex++;
        result += withDigits[identicalIndex];
        const lastPart = withDigits.substr(identicalIndex + 1);
        const [, digits, symbolEnd] = /([0-9]{2})(.*)$/.exec(lastPart);

        const symbolHtmlEnd = symbolEnd ? `<span class="symbol">${symbolEnd}</span>` : "";

        const htmlResult = result.replace(/^([^0-9\s.-]+)/, '<span class="symbol">$1</span>');

        return this.domSanitizer.bypassSecurityTrustHtml(`${htmlResult}<small style="font-size: .85em;">${digits}</small>${symbolHtmlEnd}`);
    }
}
